import { create } from 'zustand';
import type { TwoFAState } from './types';

export const useTwoFAStore = create<TwoFAState>()(
  (set, get) => ({
    isOnTwoFA: null,
    resolver: null,
    user: null,
    confirmedUser: null,
    beginProcessTwoFA: (user) => {
      set({ isOnTwoFA: true, user });
      return new Promise<void>((resolve) => {
        set({
          resolver: () => {
            set({ resolver: null });
            resolve();
          },
        });
      });
    },

    successTwoFA: (confirmedUser) => {
      const resolver = get().resolver;
      if (resolver) resolver();
      set({ confirmedUser, resolver: null });
    },

    resetTwoFAState: () => {
      set({
        isOnTwoFA: null,
        resolver: null,
        user: null,
        confirmedUser: null,
      });
    },
  }),
);
